"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = AuthorisationConsumer;

var _react = _interopRequireDefault(require("react")),
    _clientAuth = require("@devsta/client-auth"),
    _NotFound = _interopRequireDefault(require("../../NotFound")),
    _NoOrganisations = _interopRequireDefault(require("../../NoOrganisations")),
    _AuthorisationContext = require("../context/AuthorisationContext");

function AuthorisationConsumer(_ref) {
  var children = _ref.children,
      requiresOrganisation = _ref.requiresOrganisation;
  return _react["default"].createElement(_AuthorisationContext.AuthorisationContextConsumer, null, function (_ref2) {
    var organisationMemberships = _ref2.organisationMemberships,
        organisation = _ref2.selectedOrganisation,
        updateSelectedOrganisation = _ref2.updateSelectedOrganisation,
        _credentials$get = _clientAuth.credentials.get(),
        user = _credentials$get.user,
        auth = _credentials$get.auth,
        selectedOrganisation = organisation || {
      permissions: [],
      includedAddonTypes: []
    };

    return requiresOrganisation ? !user || !auth || auth && user.isAnonymous ? _react["default"].createElement(_NotFound["default"], null) : organisationMemberships && organisationMemberships.length ? children({
      organisationMemberships: organisationMemberships,
      selectedOrganisation: selectedOrganisation,
      updateSelectedOrganisation: updateSelectedOrganisation
    }) : _react["default"].createElement(_NoOrganisations["default"], null) : children({
      organisationMemberships: organisationMemberships,
      selectedOrganisation: selectedOrganisation,
      updateSelectedOrganisation: updateSelectedOrganisation
    });
  });
}